<template>
    <label>
        <slot></slot>
        <span v-if="required" class="text-red-500 inline-block ml-1">*</span>
    </label>
</template>
<script>
export default {
    props: {
        required: {
            type: Boolean,
            default: false
        }
    }
}
</script>
